import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=0423bb60&"
import script from "./FavoriteButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteButton.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports